import * as React from 'react';
import {emotionStyled} from '@packages/utilities/styled';
import {type RadioSelectProps} from './RadioSelect.types';
import {RadioSelectItem} from './RadioSelectItem';
import {useRadioSelect} from './useRadioSelect';

const View = emotionStyled('div')({
  width: 224,
});

export const RadioSelect = React.forwardRef<any, RadioSelectProps>(
  (props, ref) => {
    const {items = [], getItemProps, ...rest} = useRadioSelect(props);

    return (
      // @ts-expect-error - TS2769 - No overload matches this call.
      <View data-legacy-ds="RadioSelect" {...rest} ref={ref}>
        {items.map((item, index) => (
          // @ts-expect-error - TS2783 - 'key' is specified more than once, so this usage will be overwritten.
          <RadioSelectItem key={item.key} {...getItemProps({item, index})} />
        ))}
      </View>
    );
  }
);

export default RadioSelect;
